/** Echo's indigo, as used by the logo and the recommended-plan look of the billing screens. */
export const BRAND = {
  main: '#5b50e8',
  dark: '#3b31b5',
  deep: '#1e1b4b',
  tint: '#eeedfd',
  line: '#c9c5f7',
} as const;

/** Legal pages on the landing page (German; written by another part of the project). */
export const LEGAL_LINKS = {
  terms: 'https://lingoping.com/nutzungsbedingungen',
  privacy: 'https://lingoping.com/datenschutz',
  withdrawal: 'https://lingoping.com/widerruf',
  refund: 'https://lingoping.com/refund',
  imprint: 'https://lingoping.com/impressum',
} as const;

/** The public cancel page ("Verträge hier kündigen"), on the same site as the dashboard. */
export const CANCEL_PAGE_PATH = '/kuendigen';
